module.exports = __webpack_public_path__ + "img/Vermutete_Gefahr.43a25a7a.svg";